/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const pushSendDateModelSchema = z.object({
    "sendOnDate": z.string().datetime({ offset: true }).describe("Дата отправки в UTC").nullable().nullish()
    })